module.exports = __webpack_public_path__ + "static/media/facebook.1b8c4425.svg";